<template>
    <div>
        <b-form class="step-form" @submit.stop.prevent="onSave">
            <div v-if="!showPageLoader" class="row">
                <div class="col-lg-12">
                    <div class="row">
                        <div
                            v-for="(field, index) in fields"
                            :key="field._id || field.key || index"
                            :class="{
                                [field.class]: true,
                                'col-lg-12': field.type == 'heading',
                                'col-md-4':
                                    field.type !== 'heading' && !field.class,
                                'col-md-6': field.column == 6,
                                'col-md-8': field.column == 8,
                                'col-md-12': field.column == 12,
                            }"
                        >
                            <div
                                v-if="field.type == 'heading' && index > 0"
                                class="form-border"
                            ></div>

                            <component
                                :is="field.type"
                                :field="field"
                                :data-segment-id="dataSegmentId"
                                @onBlur="onBlur"
                            ></component>
                        </div>
                        <div class="col-lg-12">
                            <div class="form-border"></div>
                        </div>
                    </div>
                    <!-- <b-button
                        size="sm"
                        class="mr-3"
                        variant="secondary"
                        @click="onBack"
                    >
                        Back
                    </b-button> -->
                    <base-button
                        btn-type="submit"
                        btn-variant="primary"
                        btn-label="Save"
                        class="mr-3"
                        :class="loading ? 'disabled' : ''"
                        :disabled="loading"
                    ></base-button>
                    <span v-if="loading" class="secondary-color">
                        Please wait. We're processing your request...</span
                    >
                </div>
            </div>
            <!-- When data is loading -->
            <base-table-spinner v-if="showPageLoader"></base-table-spinner>
        </b-form>
        <!-- <b-modal
            ref="pmda"
            size="md"
            title="Warning"
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
        >
            <pmda-modal @selection="acceptPmda"></pmda-modal>
        </b-modal> -->
        <b-modal
            ref="identityNumberExists"
            size="md"
            title="Warning"
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
        >
            <div class="wrapper">
                <h5 style="margin-bottom: 25px">
                    {{ `${errorMsg} Please contact support@jsil.com.` }}
                </h5>
                <b-button
                    size="sm"
                    class="mr-3"
                    variant="secondary"
                    @click="onClick"
                >
                    CLOSE
                </b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

import request from '@/utils/request'

import Heading from '@/components/registration/Heading.vue'
import TextField from '@/components/registration/TextField.vue'
import TextArea from '@/components/registration/TextArea.vue'
import DatePicker from '@/components/registration/DatePicker.vue'
import List from '@/components/registration/List.vue'
import Banks from '@/components/registration/Banks.vue'
import Dropdown from '@/components/registration/Dropdown.vue'
import Radio from '@/components/registration/Radio.vue'
import Checkbox from '@/components/registration/Checkbox.vue'
import PhoneNumber from '@/components/registration/PhoneNumber.vue'
import IdentityType from '@/components/registration/IdentityType.vue'
import IdentityDocumentExpiry from '@/components/registration/IdentityDocumentExpiry.vue'
import Country from '@/components/registration/Country.vue'
import MaritalStatus from '@/components/registration/MaritalStatus.vue'
import States from '@/components/registration/States.vue'
import Cities from '@/components/registration/Cities.vue'
import ZakatDeduction from '@/components/registration/ZakatDeduction.vue'
import InternetBanking from '@/components/registration/InternetBanking.vue'
import MonthlyIncome from '@/components/registration/MonthlyIncome.vue'
import Dividend from '@/components/registration/Dividend.vue'
import Nationality from '@/components/registration/Nationality.vue'
import SourceIncome from '@/components/registration/SourceIncome.vue'
import Occupation from '@/components/registration/Occupation.vue'
import TaxId from '@/components/registration/TaxId.vue'
import WorkType from '@/components/registration/WorkType.vue'
import Industry from '@/components/registration/Industry.vue'
import OtherNationalities from '@/components/registration/OtherNationalities'
// import PmdaModal from '@/components/registration/PmdaModal'
import IbanNumber from '@/components/registration/IbanNumber.vue'
import DocumentNumber from '@/components/registration/DocumentNumber.vue'
import RelationPrinciple from '@/components/registration/RelationPrinciple.vue'
import Religion from '@/components/registration/Religion.vue'
import ContactUsVue from '../ContactUs.vue'
import setupProfileHelper from '@/mixins/setupProfileHelper'

export default {
    mixins: [setupProfileHelper],
    /*
|--------------------------------------------------------------------------
| Component > components
|--------------------------------------------------------------------------
*/
    components: {
        Heading,
        TextField,
        TextArea,
        DatePicker,
        List,
        Dropdown,
        Radio,
        Checkbox,
        PhoneNumber,
        IdentityType,
        IdentityDocumentExpiry,
        Country,
        Nationality,
        TaxId,
        WorkType,
        Industry,
        OtherNationalities,
        // PmdaModal,
        DocumentNumber,
        Banks,
        Dividend,
        MaritalStatus,
        States,
        Cities,
        InternetBanking,
        MonthlyIncome,
        Occupation,
        SourceIncome,
        IbanNumber,
        ZakatDeduction,
        RelationPrinciple,
        Religion,
    }, // End of Component > components

    /*
|--------------------------------------------------------------------------
| Component > props
|--------------------------------------------------------------------------
*/
    props: {}, // End of Component > props

    /*
|--------------------------------------------------------------------------
| Component > data
|--------------------------------------------------------------------------
*/
    data() {
        return {
            section: 'setup-profile',
            fields: [],
            showPageLoader: true,
            errorMsg: null,
            countryData: [],
            nat: '',
            natId: '',
        }
    }, // End of Component > data

    /*
|--------------------------------------------------------------------------
| Component > computed
|--------------------------------------------------------------------------
*/
    computed: {
        ...mapState({
            restrictDuplicateCustomers: (state) =>
                state.registration.restrictDuplicateCustomers,
        }),

        ...mapGetters(['loading', 'dataSegmentId']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    }, // End of Component > mounted

    /*
|--------------------------------------------------------------------------
| Component > watch
|--------------------------------------------------------------------------
*/
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getRecords()
            }
        },
    }, // End of Component > watch

    /*
|--------------------------------------------------------------------------
| Component > mounted
|--------------------------------------------------------------------------
*/
    async mounted() {
        window.fbq('track', 'PageView')
        if(this.$route.path.includes("/account-info")) {
            this.$store.dispatch('trackEvent', {event: "JS | SSA Register Account Info"});
        } else  {
            this.$store.dispatch('trackEvent', {event: "JS | SSA Register Setup Profile"});
        }

        this.getRecords()

    }, // End of Component > computed
    /*
|--------------------------------------------------------------------------
| Component > methods
|--------------------------------------------------------------------------
*/
    methods: {
       
        validateAllCustom(formData) {
            // Issuance date should not be less than Date of Birth
            if (
                formData &&
                formData.identityInfo &&
                formData.identityInfo.IssuanceDate &&
                formData.basicInfo.dateOfBirth
            ) {
                if (
                    formData.basicInfo.dateOfBirth >
                    formData.identityInfo.IssuanceDate
                ) {
                    return {
                        valid: false,
                        error: 'Issuance Date should not be less than Date of Birth',
                    }
                }
            }

            // Issuance Date earlier than expiry date
            if (
                formData &&
                formData.identityInfo &&
                formData.identityInfo.IssuanceDate &&
                formData.identityInfo.expiryDate
            ) {
                const result = this.earlierDateValidator(
                    formData.identityInfo.IssuanceDate,
                    'Issuance Date',
                    formData.identityInfo.expiryDate,
                    'Expiry Date'
                )
                if (result && result.valid) {
                    return result
                }
            }
        },
        onBlur(value) {
            // console.log('value ', value)
            this.checkIdentityNumber(value)
        },

        async checkIdentityNumber(value) {
            let dataSegmentId = this.dataSegmentId
            if (dataSegmentId) {
                try {
                    const params = {}
                    params.dataSegmentId = dataSegmentId
                    params.number = value

                    const { data } = await request({
                        url: `/customers/exists`,
                        method: 'get',
                        params,
                    })
                    // console.log('response: ', data)
                    if (!data.exists) {
                        this.$store.commit('updateField', {
                            key: 'identityInfo.number',
                            value: value,
                        })
                    }
                    // console.log(this.$store.state.registration.form.identityInfo.number)
                } catch (e) {
                    this.errorMsg = e
                    this.$refs.identityNumberExists.show()
                }
            }
        },

        onClick() {
            this.$refs.identityNumberExists.hide()
            this.$store.commit('updateField', {
                key: 'identityInfo.number',
                value: null,
            })
        },

        // Comparison between Dates Validation
        earlierDateValidator(
            earlierDate,
            earlierDateLabel,
            lateDate,
            lateDateLabel
        ) {
            if (earlierDate > lateDate) {
                return {
                    valid: false,
                    error:
                        earlierDateLabel +
                        ' should be earlier than ' +
                        lateDateLabel,
                }
            }
        },

        submit2() {
            this.$store.commit('updateField', {
                key: 'ssaForms.form2.valid',
                value: true,
            })

            /**
             * Pre Populate Fatca Info
             */

            if (this.$store.state.registration.form.identityInfo.number) {
                let fatcaCnic =
                    this.$store.state.registration.form.identityInfo.number.replace(
                        /-/g,
                        ''
                    )
                this.$store.commit('updateField', {
                    key: 'fatcaInfo.CNICNumber',
                    value: fatcaCnic,
                })
            }

            this.$store.commit('updateField', {
                key: 'fatcaInfo.titleOfAcc',
                value: this.$store.state.registration.form.basicInfo.firstName,
            })

            let placeofbirth =
                this.$store.state.registration.form.basicInfo.placeOfBirth
            if (placeofbirth) {
                this.$store.commit('updateField', {
                    key: 'fatcaInfo.placeOfBirth',
                    value: this.$store.state.registration.form.basicInfo
                        .placeOfBirth,
                })
            }
            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    name: 'public-registration-kyc-ssa',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
            } else {
                this.$router.push('/ssa-customer/kyc')
            }
        },

        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async onSubmit() {
            // validate the form fields

            const result = await this.$validator.validateAll()

            // Form State Data
            const formData = this.$store.state.registration.form

            const resultCustom = this.validateAllCustom(formData)

            // Check if validation fails
            if (result) {
                this.syncAddress2FromPrimaryWhenSameAsAddress()
                if (resultCustom && !resultCustom.valid) {
                    this.$store.commit('updateField', {
                        key: 'ssaForms.form2.valid',
                        value: false,
                    })
                    this.$store.commit(
                        'setError',
                        resultCustom && resultCustom.error
                            ? resultCustom.error
                            : ''
                    )
                } else {
                    // this.onContinue(formData)
                    this.submit2()
                }
                // }
            } else {
                this.$store.commit('updateField', {
                    key: 'forms.form2.valid',
                    value: false,
                })
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method
async onSave() {
            const result = await this.$validator.validateAll()
            // Form State Data
            const formData = this.$store.state.registration.form

            const resultCustom = this.validateAllCustom(formData)

            // Check if validation fails
            if (result) {
                this.syncAddress2FromPrimaryWhenSameAsAddress()
                if (resultCustom && !resultCustom.valid) {
                    this.$store.commit('updateField', {
                        key: 'forms.form2.valid',
                        value: false,
                    })
                    this.$store.commit(
                        'setError',
                        resultCustom && resultCustom.error
                            ? resultCustom.error
                            : ''
                    )
                } else {
                    let registrationUrl =
                        '/customers/update-individual-customer'
                    this.$store.commit('setLoading', true)

                    try {
                        const formData = this.$store.state.registration.form
                        // formData.dataSegmentId = this.dataSegmentId

                        const { data } = await request({
                            url: registrationUrl,
                            method: 'post',
                            data: formData,
                        })

                        this.$toasted.show('Changes saved successfully', {
                            duration: 3000,
                            type: ['success'],
                        })

                        this.$store.commit('setLoading', false)
                    } catch (errors) {
                        this.$store.commit('setError', errors)
                        this.$store.commit('setLoading', false)
                    }
                }
                // }
            } else {
                this.$store.commit('updateField', {
                    key: 'forms.form2.valid',
                    value: false,
                })
                this.$store.commit('setError', this.errors.all()[0])
                // console.log('Errors', this.errors.all())
            }

            // }
        },
        /**
         * get the form fields when required
         *
         * @return {void}
         */
        async getRecords() {
            try {
                let { data } = await request({
                    url: `/form-builder/`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        section: this.section,
                    },
                })

                this.showPageLoader = false
                let languageOption =
                    this.$store.state.registration.form.languageOption

                if (languageOption == 'urd') {
                    for (var i = 0; i < data.data.length; i++) {
                        data.data[i].label = data.data[i].urduLabel
                    }
                }

                this.fields = data.data
                this.allFields = data.data
                this.lockProvidedIdentityDatesOnFields()
                this.$nextTick(() => {
                    if (this.addNominee == 'No') {
                        this.hideNomineeFields()
                    }
                    if (this.isMinorAccount == 'No') {
                        this.hideMinorForm()
                    }
                })
            } catch (error) {}
            this.$store.commit('setLoading', false)
        }, // End of getRecords() method

        onBack() {
            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    name: 'public-registration-identity-document-ssa',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
            } else {
                this.$router.push({
                    name: 'ssa-identity-document',
                })
            }
        },
    }, // End of Component > watch
} // End of export default
</script>
